import React from 'react';
import AgentCard from '../../components/AgentCard/AgentCard';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import './viewmarketingexec.scss';
import { ReactComponent as Email } from '../../images/email.svg';
import { useNavigate } from 'react-router-dom';

function ViewMarketingExec() {
	const navigate = useNavigate();
	return (
		<div className='vmexec'>
			<div className='hcont'>
				<Button
					style={{
						width: 'fit-content',
						fontSize: '18px',
						padding: '10px',
						background: 'white',
						color: 'var(--primary-color)',
						display: 'block',
					}}
					text='+ Add New Marketing Executive Agent'
					onClick={() => navigate('add')}
				/>
				<form onSubmit={(e) => e.preventDefault()}>
					<Input
						placeholder='By Name'
						style={{ fontSize: '18px', padding: '10px 20px' }}
					/>
					<Input
						placeholder='By Month Hired'
						style={{ fontSize: '18px', padding: '10px 20px' }}
					/>

					<Button
						style={{
							width: '100px',
							fontSize: '16px',
							padding: '10px',
							color: 'white',
							backgroundColor: 'var(--primary-color)',
							display: 'block',
						}}
						text='Filter'
					/>
				</form>
			</div>
			<div className='vmcontent'>
				<p>Your most recent Market Executives</p>
				<div className='vmagent'>
					<AgentCardMod />
					<AgentCardMod />
					<AgentCardMod />
					<AgentCardMod />
					<AgentCardMod />
					<AgentCardMod />
				</div>
			</div>
			<div className='vmcontent'>
				<p>Market Executive List (16)</p>
				<div className='vmagent'>
					<AgentCardMod />
					<AgentCardMod />
					<AgentCardMod />
					<AgentCardMod />
					<AgentCardMod />
					<AgentCardMod />
					<AgentCardMod />
					<AgentCardMod />
					<AgentCardMod />
					<AgentCardMod />
					<AgentCardMod />
				</div>
			</div>
		</div>
	);
}

export default ViewMarketingExec;

const AgentCardMod = ({ name = 'Bryan Krailer' }) => {
	return (
		<AgentCard>
			<div className='vmitem'>
				<span>{name}</span>
				<span>
					<Email />
					&nbsp;agent@bpohomes.com
				</span>
			</div>
		</AgentCard>
	);
};
